import {inject, injectable} from 'inversify';

import type {CoreClientUsersReadParams} from '../../../../../api/types/core/methods';
import type {Nullable} from '../../../../../utils/utility-types';
import type {UserModel} from '../../../../domain/User/User.model';
import type {FetchUserQuery} from '../FetchUser.query';

import {apiRequest} from '../../../../../api/utils/apiRequest';
import {expandObj} from '../../../../../api/utils/expand';
import {UserMapperJrpc} from '../../../../domain/User/mappers/User.mapper.jrpc';
import {EnvProviderService} from '../../../../system/env/EnvProvider.service';

@injectable()
export class FetchUserQueryJrpc implements FetchUserQuery {
  constructor(
    @inject(UserMapperJrpc) private readonly mapper: UserMapperJrpc,
    @inject(EnvProviderService)
    private readonly env: EnvProviderService,
  ) {}

  async exec(props: FetchUserQuery.Props): Promise<Nullable<UserModel>> {
    const expand = this.mapper.expand.getByEnv();

    const response = await apiRequest<CoreClientUsersReadParams>({
      method: 'client.users.read',
      params: {
        _id: props.id,
        expand,
      },
    });

    if (!response.user) {
      return null;
    }

    const expanded = expandObj(response.user, {
      expand,
      expanded: response._expanded,
    });

    return this.mapper.mapDataToModel(expanded);
  }
}
